export enum ElementId {
  NotificationTitleText = 'notificationTitleText',
  NotificationDescriptionText = 'notificationDescriptionText',
  GetRewardButton = 'getRewardButton',
}
